'use client';

import dynamic from 'next/dynamic';

// Same lazy, client-only load as the widget itself — mapbox-gl is a sizeable bundle and must
// never run during SSR.
const PartnerMap = dynamic(() => import('./PartnerMap').then(m => ({ default: m.PartnerMap })), {
    ssr: false,
});

/**
 * The map with nothing on it but the availability regions. Rendered when we have no partner
 * offerings to show, in place of the widget.
 *
 * `PartnerMap` degrades to exactly this on its own: with no partners there are no markers, the
 * overview bounds come from the region geometry alone, and the legend drops every entry but
 * "Beschikbare regio's". Nothing here is a second implementation of the map — it is the same
 * component with an empty partner list.
 */
export const RegionsOnlyMap: React.FC<{ availableRegionNames: string[] }> = props => (
    <PartnerMap
        partners={[]}
        selectedActivityId={null}
        onSelect={() => undefined}
        location={null}
        mode="fixed"
        availableRegionNames={props.availableRegionNames}
    />
);
